/**
 * Bare XHR PUT against a presigned URL. axiosInstance attaches an Authorization
 * header that S3 rejects on a presigned URL, so the upload cannot go through it.
 */
export function putToPresignedUrl(
  url: string,
  body: Blob | File,
  contentType: string,
  opts?: { onProgress?: (pct: number) => void; signal?: AbortSignal },
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url);
    xhr.setRequestHeader("Content-Type", contentType);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) opts?.onProgress?.(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () =>
      xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`));
    xhr.onerror = () => reject(new Error("Upload failed"));
    xhr.onabort = () => reject(new DOMException("Aborted", "AbortError"));

    const signal = opts?.signal;
    if (signal) {
      if (signal.aborted) {
        reject(new DOMException("Aborted", "AbortError"));
        return;
      }
      const onAbort = () => xhr.abort();
      signal.addEventListener("abort", onAbort, { once: true });
      xhr.addEventListener("loadend", () => signal.removeEventListener("abort", onAbort));
    }

    xhr.send(body);
  });
}
